import type { TreeTag } from '#domains/tags';
import { TAG_INDENTATION } from '#lib/constants';
import { NavLink } from '../../../components';
import TagRowIcon from './TagRowIcon';

type TagRowProps = {
  tag: TreeTag;
};

export const TagRow = ({ tag }: TagRowProps) => {
  const style = {
    paddingLeft: tag.level * TAG_INDENTATION
  };

  return (
    <NavLink
      leftSection={<TagRowIcon tag={tag} />}
      search={{ q: `tag:${tag.fullName}` }}
      style={style}
      to="/search"
    >
      {tag.name}
    </NavLink>
  );
};
